import React from 'react';
import PropTypes from 'prop-types';
import GenericIcon from './fontIcons/genericIcon';
import './fontIcons/fontIconStyle.css';

const BenefitsIcon = ({ ...props }) => {
  const { color, size } = props;
  return (
    <GenericIcon color={color} size={size} fontClass="icon-ic_beneficios" />
  );
};

BenefitsIcon.propTypes = {
  color: PropTypes.string,
  size: PropTypes.string,
};

export default BenefitsIcon;
